import { getScrollParent, addClass, removeClass, getContainingBlock, browserScrollbarSize } from '../../../../core/utils/src/dom';
export var positionScrollbar = function (scrollbar, scrollbarContent, content, table, root, stuckClassName) {
    var rootEl = root();
    var scrollParent = rootEl ? getScrollParent(rootEl) : document.body;
    var stuck = false;
    var scrollbarHeight = browserScrollbarSize().height;
    var scrollbarEl = scrollbar();
    var scrollbarContentEl = scrollbarContent();
    if (scrollbarHeight && scrollbarEl && scrollbarContentEl) {
        scrollbarEl.style['margin-top'] = "-" + scrollbarHeight + "px";
        scrollbarEl.style.height = scrollbarHeight + "px";
        scrollbarContentEl.style.height = scrollbarHeight + "px";
    }
    var setStuck = function (nextStuck) {
        var scrollbarEl = scrollbar();
        if (nextStuck !== stuck && scrollbarEl) {
            stuck = nextStuck;
            if (stuck) {
                addClass(scrollbarEl, stuckClassName);
            }
            else {
                removeClass(scrollbarEl, stuckClassName);
            }
        }
    };
    var updatePosition = function () {
        var scrollbarEl = scrollbar();
        var scrollbarContentEl = scrollbarContent();
        var contentEl = content();
        var tableEl = table();
        var rootEl = root();
        if (!scrollbarEl || !scrollbarContentEl || !contentEl || !tableEl || !rootEl) {
            return;
        }
        var containingBlock = getContainingBlock(rootEl);
        var containingBlockRect = containingBlock ? containingBlock.getBoundingClientRect() : { top: 0, left: 0 };
        var oldDisplayValue = scrollbarEl.style.display;
        scrollbarEl.style.display = 'block';
        var scrollbarRect = scrollbarEl.getBoundingClientRect();
        scrollbarEl.style.display = oldDisplayValue;
        var contentRect = contentEl.getBoundingClientRect();
        var tableElRect = tableEl.getBoundingClientRect();
        var rootElRect = rootEl.getBoundingClientRect();
        var bottom = scrollParent ? scrollParent.getBoundingClientRect().bottom : window.innerHeight;
        if (contentRect.top + scrollbarRect.height < bottom &&
            bottom < contentRect.bottom - scrollbarRect.height &&
            tableElRect.width > rootElRect.width) {
            setStuck(true);
            scrollbarEl.style.top = bottom - containingBlockRect.top + "px";
            scrollbarEl.style.left = rootElRect.left - containingBlockRect.left + "px";
            scrollbarContentEl.style.width = tableElRect.width + "px";
            scrollbarEl.style.width = rootElRect.width + "px";
            // Browsers reset the scrolling position when the element is not displayed, so this line restores it.
            scrollbarEl.scrollLeft = Number(scrollbarEl.getAttribute('data-scroll-left'));
        }
        else {
            setStuck(false);
        }
    };
    (scrollParent || window).addEventListener('scroll', updatePosition);
    return [updatePosition, function () { return (scrollParent || window).removeEventListener('scroll', updatePosition); }];
};
//# sourceMappingURL=utils.js.map